/**
 * VIB-1189: beregninger for avsluttet-varianten av prosjektlista + summeringslinje.
 *
 * Definisjoner forankret i kpi-source-of-truth.md:
 * - Endelig timepris (reell_timepris, Erik-lock 2026-05-15) = bf_actual / brukte timer.
 * - Budsjettavvik = (brukt − solgt) / solgt × 100.
 * Summeringslinjen er VEKTET (sum/sum), ikke snitt av per-prosjekt-verdier.
 */

// Reell/endelig timepris bor i project-rates.ts sammen med est. timepris, så
// avsluttet-lista, den aktive lista og prosjektkortet deler én definisjon
// (VIB-1724). Re-eksporteres her fordi den er del av denne modulens API.
import { reellTimepris } from "./project-rates";

export { reellTimepris };

/** Budsjettavvik i prosent: (brukt − solgt) / solgt × 100. Null hvis ingen solgte timer. */
export function budsjettavvikPct(timerSolgt: number, timerBrukt: number): number | null {
  if (timerSolgt <= 0) return null;
  return ((timerBrukt - timerSolgt) / timerSolgt) * 100;
}

export interface CompletedAgg {
  bfActual: number;
  timerSolgt: number;
  timerBrukt: number;
}

export interface CompletedTotals {
  antall: number;
  bfActual: number;
  timerSolgt: number;
  timerBrukt: number;
  /** vektet: (Σbrukt − Σsolgt)/Σsolgt × 100 */
  budsjettavvikPct: number | null;
  /** vektet: Σbf_actual / Σbrukt */
  endeligTimepris: number | null;
}

/** Vektet summeringslinje over de viste avsluttede prosjektene. */
export function computeCompletedTotals(rows: CompletedAgg[]): CompletedTotals {
  let bfActual = 0;
  let timerSolgt = 0;
  let timerBrukt = 0;
  for (const r of rows) {
    bfActual += r.bfActual;
    timerSolgt += r.timerSolgt;
    timerBrukt += r.timerBrukt;
  }
  return {
    antall: rows.length,
    bfActual,
    timerSolgt,
    timerBrukt,
    budsjettavvikPct: budsjettavvikPct(timerSolgt, timerBrukt),
    endeligTimepris: reellTimepris(bfActual, timerBrukt),
  };
}
